import React from 'react';

export const WarpcastLogo = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="47"
      height="47"
      viewBox="0 0 47 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="0.5" width="46" height="46" rx="23" fill="#472A91" />
      <path
        d="M28.4961 16.951L26.9187 22.875L25.3362 16.951H21.6944L20.0968 22.9186L18.5043 16.951H14.3564L18.2108 30.0489H21.7893L23.5004 23.9667L25.2115 30.0489H28.7977L32.6436 16.951H28.4961Z"
        fill="white"
      />
    </svg>
  );
};
